import { useState, useEffect } from "react";
import { getLgBreakpoint } from "@/utils/breakpoints";

/**
 * Returns `true` when the viewport width is below the Tailwind `lg`
 * breakpoint (read from the `--breakpoint-lg` CSS custom property).
 * Listens for resize events so the value stays in sync as the window
 * is resized. Defaults to `false` during SSR.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.innerWidth < getLgBreakpoint()
      : false,
  );

  useEffect(() => {
    const breakpoint = getLgBreakpoint();
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    setIsMobile(mql.matches);
    mql.addEventListener("change", handleChange);

    return () => mql.removeEventListener("change", handleChange);
  }, []);

  return isMobile;
}
